(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3574],{

/***/ 79521:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lazada",
      function () {
        return __webpack_require__(18625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75519);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31788);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25935);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25283);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84233);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51148);











var PageLazada = function(param) {
    var articles = param.articles, dataAdsHeader = param.dataAdsHeader;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_9__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    if (!articles) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_5__["default"], {
        dataAdsHeader: dataAdsHeader,
        sessionSevId: sessionSevId
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                noindex: true,
                nofollow: true,
                title: articles === null || articles === void 0 ? void 0 : articles.title,
                description: articles === null || articles === void 0 ? void 0 : articles.description,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_URL */ .FX, "/lazada")
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_7__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_8___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_7__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_8___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                __th_page="lazada";\n              '
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layouts__WEBPACK_IMPORTED_MODULE_4__["default"], {
                sessionSevId: sessionSevId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lazada-page",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "lazada-top",
                            style: {
                                filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: articles === null || articles === void 0 ? void 0 : articles.urlAll,
                                    target: "_blank",
                                    className: "container lazada-logo",
                                    rel: "noopener noreferrer nofollow",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_IMG */ .T, "/static/lazada/lazada-logo.svg"),
                                        alt: "lazada-logo",
                                        width: "100%"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: articles === null || articles === void 0 ? void 0 : articles.urlAll,
                                    target: "_blank",
                                    className: "lazada-banner",
                                    rel: "noopener noreferrer nofollow",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_IMG */ .T, "/").concat(articles === null || articles === void 0 ? void 0 : articles.bannerDesktopImage),
                                            alt: articles === null || articles === void 0 ? void 0 : articles.altBannerDesktop,
                                            className: "desktop",
                                            width: "100%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_IMG */ .T, "/").concat(articles === null || articles === void 0 ? void 0 : articles.bannerMobileImage),
                                            alt: articles === null || articles === void 0 ? void 0 : articles.altBannerMobile,
                                            className: "mobile",
                                            width: "100%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "lazada-list",
                            style: {
                                filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            className: "lazada-list-h ",
                                            children: "ช้อปครั้งนี้ มีแต่ได้กับได้"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "lazada-ul-list",
                                            children: (articles === null || articles === void 0 ? void 0 : articles.banner1.length) > 0 && articles.banner1.map(function(item, i) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: item.url || "#",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_IMG */ .T, "/").concat(item.image),
                                                            alt: item.alt,
                                                            width: "100%"
                                                        })
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "btn-lazada",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: articles === null || articles === void 0 ? void 0 : articles.urlAll,
                                        target: "_blank",
                                        rel: "noopener noreferrer nofollow",
                                        children: "ดูสินค้าทั้งหมด"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageLazada);


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(79521); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);